import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { GetAllCompanyDto } from "@/types/api/api-types";
import { usePaymentMethodShortOptions } from "@/hooks/useEnumOptions";

type GeneralInfoPaymentProps = {
  company?: GetAllCompanyDto;
};

export const GeneralInfoPayment = ({ company }: GeneralInfoPaymentProps) => {
  const { t } = useTranslation("boClients");
  return (
    <div className="flex w-full flex-1 flex-col gap-6 lg:px-8">
      <div className="flex flex-row justify-between gap-2 border-0 border-b border-gray-200 pb-5">
        <div className="items-left flex flex-col gap-2">
          <h2 className="text-lg font-semibold">{t("clientPayment.title")}</h2>
          <p className="text-sm text-gray-600">{t("clientPayment.subtitle")}</p>
        </div>
      </div>
      <div className="flex flex-col gap-6">
        {company?.billingEntities.map((billingEntity, index) => (
          <BillingEntityPaymentElem
            key={index}
            isDefault={billingEntity.isDefault}
            name={billingEntity.companyName}
            mode={billingEntity.paymentMethod}
          />
        ))}
      </div>
    </div>
  );
};

type BillingEntityPaymentElemProps = {
  isDefault: boolean;
  name: string;
  mode: string;
};

const BillingEntityPaymentElem = ({ isDefault, name, mode }: BillingEntityPaymentElemProps) => {
  const { t } = useTranslation("boClients");
  const paymentMethodShortOptions = usePaymentMethodShortOptions();
  return (
    <div className="flex max-w-[440px] flex-row justify-between gap-2 rounded-lg border border-gray-300 bg-white p-4 align-middle">
      <div className="gpa-2 flex flex-col gap-1">
        <p className="text-xs font-medium text-gray-600">
          {isDefault
            ? t("clientPayment.defaultBillingEntity")
            : t("clientPayment.additionalBillingEntity")}
        </p>
        <p className="text-base font-medium text-gray-900">{name}</p>
      </div>
      <div className="flex w-fit flex-row items-center justify-center gap-2 rounded-lg border border-[#BBF7D0] bg-[#F0FDF4] px-2 py-0">
        <Check className="size-4 text-[#15803D]" />
        <p className="h-fit w-fit text-sm font-medium text-[#15803D]">
          {paymentMethodShortOptions.find((el) => el.value === mode)?.label ||
            t("clientPayment.unknownMethod")}
        </p>
      </div>
    </div>
  );
};
